import {Tab} from "semantic-ui-react";
import * as React from "react";
import {TestSuppressionScriptModalSingle} from "./TestSuppressionScriptModalSingle";
import {TestSuppressionScriptModalMulti} from "./TestSuppressionScriptModalMulti";
import {ConfigContext} from "../../../../context/ConfigContext";
import {clampTabIndex} from "../../../../context/TabSession";

const panes = [
    { menuItem: 'Multi', render: props => <Tab.Pane><TestSuppressionScriptModalMulti
            queue={props.queue}
            history={props.history}
            updateResponse={props.updateResponse}/>
        </Tab.Pane> },
    { menuItem: 'Single', render: props => <Tab.Pane><TestSuppressionScriptModalSingle
            queue={props.queue}
            updateResponse={props.updateResponse}/>
    </Tab.Pane> },

]


const TestSuppressionScriptModalTabView = props => {
    const context = React.useContext(ConfigContext);

    return <Tab
        {...props = props}
        panes={panes}
        defaultActiveIndex={clampTabIndex(context.tabSession.testSuppressionScriptModalTab, panes)}
        onTabChange={(_, data) => {
            context.setSingleTabSession("testSuppressionScriptModalTab", parseInt(data.activeIndex.toString()))
        }}
    />
}

export default TestSuppressionScriptModalTabView